module.exports = __webpack_public_path__ + "img/133.08b6c6de.jpg";